// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"39424": "663922e2c223","574": "e3dfe3a57a46","5856": "0308423753f6","58747": "7dd06ec73d7c","6980": "e73d754e4073",}[chunkId] + ".css"
}